<style scoped>
</style>

<template>
  <!-- <AppPage @on-rows-change="onRowsChange" :page="pager.page" :limit="pager.limit" :total="pager.total" @on-page-change="onPageChange"> -->
  <AppPage>
    <template v-slot:header>
      <Row type="flex" justify="space-between" align="middle" style="margin-bottom: 10px;">
        <i-col>
          <Row type="flex" :wrap="false" :gutter="10" align="middle">
            <i-col>
              <fm-title :title-text="title" :note-text="note"></fm-title>
            </i-col>
          </Row>
        </i-col>
        <i-col>
          <Button @click="refresh" :loading="loading.load" icon="md-refresh">刷新</Button>
        </i-col>
      </Row>
    </template>
    <template v-slot="{ contentHeight }">
      <PurchaseTable @repeal="repeal" v-if="accordingType === 'goods_purchase_detail'" :height="contentHeight" :dataList="dataList" :loading="loading.load" />
      <SaleTable @repeal="repeal" v-if="accordingType === 'goods_sale_detail'" :height="contentHeight" :dataList="dataList" :loading="loading.load" />
      <SaleTable @repeal="repeal" v-if="accordingType === 'goods_sale_after_detail'" :height="contentHeight" :dataList="dataList" :loading="loading.load" />
    </template>
  </AppPage>
</template>

<script>
import AppPage from '../../../components/page/base.vue'
import request from '../../../api/index'
import PurchaseTable from './table/purchase.vue'
import SaleTable from './table/sale.vue'

export default {
  components: { PurchaseTable, SaleTable, AppPage },
  props: {
    accordingType: { type: String, default: null },
    accordingDataId: { type: Number, default: null }
  },
  data () {
    return {
      routerName: this.$route.name,
      pager: {
        page: 1,
        limit: 10,
        total: 0
      },
      loading: {
        load: false,
        submit: false,
      },
      dataList: [],
      accordingData: null
    }
  },
  computed: {
    title () {
      if (this.accordingType === 'goods_purchase_detail') {
        return '采购入库'
      } else if (this.accordingType === 'goods_sale_after_detail') {
        return '售后出库'
      } else {
        return '销售出库'
      }
    },
    note () {
      return this.accordingData ? this.accordingData.goodsName : null
    },
    scmGoodsUseTypeList () {
      return this.$store.getters.scmGoodsUseTypeList
    },
    scmGoodsStatusList () {
      return this.$store.getters.scmGoodsStatusList
    },
    scmStockDetailActionList () {
      return this.$store.getters.scmStockDetailActionList
    }
  },
  watch: {
    accordingDataId () {
      if (this.routerName === this.$route.name) {
        this.loadAccordingData()
      }
    }
  },
  methods: {
    async loadAccordingData () {
      if (this.accordingDataId <= 0) {
        this.accordingData = null
        return
      }
      let data = []
      if (this.accordingType === 'goods_sale_detail') {
        data = await request.get('/goods_sale/detail', {
          id: this.accordingDataId
        })
      } else if (this.accordingType === 'goods_purchase_detail') {
        data = await request.get('/goods_purchase/detail', {
          id: this.accordingDataId
        })
      } else if (this.accordingType === 'goods_sale_after_detail') {
        data = await request.get('/goods_sale_after/detail', {
          id: this.accordingDataId
        })
      }
      this.accordingData = data.length > 0 ? data[0] : null
    },
    async repeal (item) {
      try {
        if (this.accordingType === 'goods_sale_detail') {
          await request.delete('/goods_sale/detail/out_send/' + this.accordingDataId, {
            goodsStockDetailId: item.id
          })
        } else if (this.accordingType === 'goods_sale_after_detail') {
          await request.delete('/goods_sale_after/detail/out_send/' + this.accordingDataId, {
            goodsStockDetailId: item.id
          })
        } else if (this.accordingType === 'goods_purchase_detail') {
          await request.delete('/goods_purchase/detail/check_in/' + item.accordingDataId, {
            goodsNotStockId: item.id
          })
        }
        this.$Message.success('撤销成功')
        this.loadData()
        this.$emit('reload')
      } catch (e) {
        this.$Modal.error({
          title: '撤销失败',
          content: e.message
        })
      }
    },
    onSearch (params) {
      if (params) {
        Object.assign(this.query, params)
      }
      this.pager.page = 1
      this.loadData()
    },
    refresh () {
      this.pager.page = 1
      this.loadData()
    },
    async onPageChange (page) {
      this.pager.page = page
      this.loadData()
    },
    async loadData () {
      const params = {
        accordingType: this.accordingType
      }

      if (this.accordingDataId) {
        params.accordingDataId = this.accordingDataId
      }

      this.loading.load = true
      try {
        const res = await request.get(this.accordingType === 'goods_sale_detail' || this.accordingType === 'goods_sale_after_detail' ? '/goods_stock/detail' : '/goods_not_stock', Object.assign(params, {
          pageNum: this.pager.page,
          pageSize: this.pager.limit
        }))

        res.data.forEach(item => {
          item.goodsUseTypeText = this.scmGoodsUseTypeList.find(v => v.value === item.goodsUseType).label
          item.goodsStatusData = this.scmGoodsStatusList.find(v => v.value === item.goodsStatus)
          if (item.action) {
            item.actionData = this.scmStockDetailActionList.find(v => v.value === item.action)
          }
        })

        this.pager.total = res.total
        this.dataList = res.data
      } catch (e) {
        this.$Modal.error({ title: '系统提示', content: e.message })
      }
      this.loading.load = false
    },
    onRowsChange (rows) {
      this.pager.page = 1
      this.pager.limit = rows
      this.loadData()
      this.loadAccordingData()
    }
  },
  mounted () {
    this.onRowsChange(999)
  }
}
</script>
